// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-api-description-js": () => import("./../../../src/templates/api-description.js" /* webpackChunkName: "component---src-templates-api-description-js" */),
  "component---src-templates-api-index-js": () => import("./../../../src/templates/api-index.js" /* webpackChunkName: "component---src-templates-api-index-js" */)
}

